// CustomModal.js
import React from "react";
import Modal from "react-modal";

import { Offer } from "../interfaces/intefaces";
import { Button } from "@mui/material";
import { useTranslation } from "../hooks/hooks";
import Icon from "./Icon";
import { CloseIcon } from "./Icons";

interface IProps {
    open: boolean;
    offer: Offer;
    onRequestClose: () => void;
}
const OfferModal = ({ open, offer, onRequestClose }: IProps) => {
    const { _e } = useTranslation();

    const handleOfferClick = () => {
        const el = document.getElementById("login-button");
        if (el !== null) {
            el.click();
        }
        onRequestClose();
    };
    const customStyles = {
        overlay: {
            zIndex: 2147483647,
            background: "transparent",
            top: "5vh",
            left: 0,
            right: 0,
            bottom: "5vh",
            padding: 0,
        },
        content: {
            background: "#fff",
            border: 0,
            borderRadius: "25px",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: "20px",
            overflow: "auto",
            maxHeight: "100%",
            width: 500,
            maxWidth: "90vw",
            marginLeft: "auto",
            marginRight: "auto",
        },
    };
    return (
        <Modal
            isOpen={open}
            onRequestClose={onRequestClose}
            contentLabel="Modal"
            ariaHideApp={false}
            shouldCloseOnOverlayClick={true}
            style={customStyles}
            className="offers-modal"
        >
            <h2 className="title">{offer.heading}</h2>
            <div dangerouslySetInnerHTML={{ __html: offer.text }} />
            <Button variant="outlined" className="variant-1" onClick={handleOfferClick}>
                {_e("I WANT IT")}
            </Button>
            <Button onClick={() => onRequestClose()} className="close-button">
                <Icon icon={CloseIcon} />
            </Button>
        </Modal>
    );
};

export default OfferModal;
